export default "__VITE_ASSET__BkMiHNF1__"